export default {
  "root": "_root_1hv53_1",
  "--type-literal": "_--type-literal_1hv53_1",
  "--type-unit": "_--type-unit_1hv53_1",
  "--type-literal--m": "_--type-literal--m_1hv53_1",
  "--type-unit--m": "_--type-unit--m_1hv53_1",
  "--type-literal--l": "_--type-literal--l_1hv53_1",
  "--type-unit--l": "_--type-unit--l_1hv53_1",
  "--type-literal--xl": "_--type-literal--xl_1hv53_1",
  "--type-unit--xl": "_--type-unit--xl_1hv53_1"
};import "ni:sha-256;Uktdx5gu5EXEAkoZbGQICvJjB_R6Z7Fiuzb-fU2zXjk";